import React, { createContext, useState } from 'react'
import { AUTH_TOKEN_KEY } from '../../contants'

export const AuthContext = createContext({
  authToken: localStorage.getItem(AUTH_TOKEN_KEY),
  setAuthToken: () => {},
})

const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(localStorage.getItem(AUTH_TOKEN_KEY))
  const value = { authToken, setAuthToken }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export default AuthProvider
